import { useQueryClient } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useStore } from '../../hooks/useStore';
import { Loading } from '../../lib/components';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import { cardOnboardingKey } from '../../queries/pxtraCard';

/** Where Swan's onboarding form sends the manager back. */
export const CardSetupReturn = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { companyStore } = useStore();
  const companyId = companyStore.company?.id ?? '';

  useEffect(() => {
    if (!companyId) return;

    queryClient.invalidateQueries({ queryKey: cardOnboardingKey(companyId) });
    navigate('/benefits/pxtra-card/settings', { replace: true });
  }, [companyId, navigate, queryClient]);

  return (
    <ContentBox>
      <p className="text-grey-700">{t('pxtraCard:setupReturn')}</p>
      <Loading />
    </ContentBox>
  );
});
